import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { Typography, Dropdown, Collapse, Input } from "antd";
import { useEffect } from "react";
import {
  loadDataSuccess,
  loadFavouriteObjects,
  loadHeaderSuccess,
  toggleFavouriteObject,
} from "redux/slices/objects";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { unmountKanbanView } from "redux/slices/kanbanView";
import { getListRecordSuccess } from "redux/slices/quotation";
import {
  CaretDownOutlined,
  SearchOutlined,
  PushpinFilled,
} from "@ant-design/icons";
import { setDataList } from "redux/slices/consolidatedView";

const { Text: TextComponent } = Typography;
const { Panel } = Collapse;
const HeaderObjectView = () => {
  const { objectsFavourite } = useSelector((state) => state.objectsReducer);
  const { defaultBrandName } = useSelector((state) => state.brandNameReducer);
  const { visibleList, objectCategory } = useSelector(
    (state) => state.objectsManagementReducer
  );
  const [category, setCategory] = useState({});
  const [valueSearch, setValueSearch] = useState("");

  const [open, setOpen] = useState(false);
  const [listObject, setListObject] = useState([]);

  const { objectId, object_id, objectID } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(loadFavouriteObjects());
  }, [dispatch]);
  useEffect(() => {
    if (open) {
      setValueSearch("");
    }
  }, [open]);

  useEffect(() => {
    if (objectCategory) {
      const CloneObjectCategory = { ...objectCategory };
      setCategory(CloneObjectCategory);
    }
  }, [objectCategory]);

  const hexToRGB = (color) => {
    if (color) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);

      return `rgb(${r}, ${g}, ${b},0.2)`;
    }
  };

  useEffect(() => {
    if (objectsFavourite) {
      let temp = [...objectsFavourite];
      temp.unshift({
        objectName: "All",
        _id: "no_id",
      });
      setListObject(temp);
    }
  }, [objectsFavourite]);

  const isDisableNagivate = (id) => {
    const pathname = window.location.pathname;

    if (
      (pathname.includes("/objects/") &&
        (objectId === id || objectID === id)) ||
      (pathname.includes("/product-list") && id === "obj_products_00000001") ||
      (pathname.includes("/sale-view/") && objectID === id)
    )
      return true;

    return false;
  };

  const menu = (
    <ContenWrap>
      <Input
        placeholder={t("common.search")}
        prefix={<SearchOutlined />}
        value={valueSearch}
        onChange={(e) => {
          setValueSearch(e.target.value);
        }}
      />
      <Collapse
        ghost
        accordion
        defaultActiveKey={["0"]}
        expandIconPosition="end"
        expandIcon={({ isActive }) => (
          <svg
            style={{ transform: isActive ? "rotate(90deg)" : "rotate(0deg)" }}
            width="5"
            height="10"
            viewBox="0 0 5 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.666682 9.66667C0.510914 9.66698 0.359957 9.61273 0.240016 9.51334C0.103678 9.40031 0.0179172 9.23767 0.00165783 9.06132C-0.0146016 8.88497 0.0399765 8.70939 0.153349 8.57334L3.14002 5L0.260016 1.42C0.148169 1.28227 0.0958365 1.10564 0.114605 0.929216C0.133374 0.752788 0.221696 0.591119 0.360016 0.480004C0.49946 0.357311 0.683767 0.298354 0.868532 0.317336C1.0533 0.336319 1.22177 0.431521 1.33335 0.580004L4.55335 4.58C4.75556 4.826 4.75556 5.18067 4.55335 5.42667L1.22002 9.42667C1.08437 9.5903 0.878839 9.67945 0.666682 9.66667Z"
              fill="#2F2929"
            />
          </svg>
        )}
      >
        {Object.entries(category).map(
          ([key, value], idx) =>
            visibleList[key] && (
              <Panel key={`${idx}`} header={key}>
                <ul>
                  {value.map((item, index) => {
                    if (
                      item.Status &&
                      item.visible &&
                      item._id !== "obj_segment_00000001" &&
                      item._id !== "obj_segment_member_00000001" &&
                      item._id !== "obj_quotation_items_00000001" &&
                      item._id !== "obj_sale_order_items_00000001" &&
                      item.Name.toLocaleLowerCase()
                        .trim()
                        .includes(valueSearch.toLocaleLowerCase().trim())
                    ) {
                      return (
                        <ItemWrap>
                          <CustomName
                            key={index}
                            isActive={
                              objectId === item._id ||
                              objectID === item._id ||
                              (window.location.pathname.includes(
                                "/product-list"
                              ) &&
                                item._id === "obj_products_00000001")
                            }
                            onClick={() => {
                              setOpen(false);
                              if (isDisableNagivate(item._id)) return;

                              if (
                                objectId !== item._id ||
                                objectID !== item.object_id
                              ) {
                                dispatch(loadDataSuccess([]));
                                dispatch(loadHeaderSuccess([]));
                                dispatch(getListRecordSuccess([]));
                                dispatch(setDataList([]));
                              }

                              if (
                                item._id === "obj_quotations_00000001" ||
                                item._id === "obj_quotation_items_00000001"
                              ) {
                                navigate("/sale-view/obj_quotations_00000001");
                              } else if (
                                item._id === "obj_opportunities_00000001" ||
                                item._id === "obj_sale_orders_00000001"
                              ) {
                                navigate(`/sale-view/${item._id}`);
                              } else if (item._id === "obj_products_00000001") {
                                navigate(`/product-list`);
                              } else {
                                navigate(`objects/${item._id}/default-view`);
                              }
                            }}
                          >
                            <TextComponent>{item.Name}</TextComponent>
                          </CustomName>

                          {objectsFavourite.findIndex(
                            (object) => object.object_id === item._id
                          ) >= 0 ? (
                            <PushpinFilled
                              style={{
                                color: defaultBrandName.theme_color,
                              }}
                              onClick={() => {
                                dispatch(
                                  toggleFavouriteObject({
                                    object_id: item._id,
                                  })
                                );
                              }}
                            />
                          ) : (
                            <PushpinFilled
                              className="pin-icon"
                              onClick={() => {
                                dispatch(
                                  toggleFavouriteObject({
                                    object_id: item._id,
                                  })
                                );
                              }}
                            />
                          )}
                        </ItemWrap>
                      );
                    } else {
                      return <></>;
                    }
                  })}
                </ul>
              </Panel>
            )
        )}
      </Collapse>
    </ContenWrap>
  );

  return (
    <CustomMenuHeader>
      <CustomDropdown
        visible={open}
        overlay={menu}
        placement="bottomRight"
        trigger="click"
        overlayClassName="object-view"
        onVisibleChange={() => setOpen(!open)}
      >
        <CustomNewButton onClick={() => setOpen(!open)}>
          <span>{t("objectLayoutField.all")}</span>
          <CaretDownOutlined />
        </CustomNewButton>
      </CustomDropdown>
      <CarouselWrap color={() => hexToRGB(defaultBrandName.theme_color)}>
        {listObject.map((item, idx) => {
          if (idx !== 0) {
            if (item && item.object_name && idx < 6) {
              return (
                <WrapItem>
                  <MenuItem
                    color={() => hexToRGB(defaultBrandName.theme_color)}
                    isActive={
                      objectId === item.object_id ||
                      object_id === item.object_id ||
                      objectID === item.object_id ||
                      (window.location.pathname.includes("product-list") &&
                        item.object_id === "obj_products_00000001")
                    }
                    key={item.object_id}
                    onClick={() => {
                      if (window.location.pathname.includes("/kanban-view/")) {
                        navigate(`/kanban-view/${item.object_id}/default-view`);
                        dispatch(unmountKanbanView());
                      } else if (
                        window.location.pathname.includes(
                          "/list-view-with-details/"
                        )
                      ) {
                        navigate(
                          `/list-view-with-details/objects/${item.object_id}/default-view`
                        );
                      } else {
                        if (isDisableNagivate(item.object_id)) return;

                        if (
                          objectId !== item.object_id ||
                          objectID !== item.object_id
                        ) {
                          dispatch(loadDataSuccess([]));
                          dispatch(loadHeaderSuccess([]));
                          dispatch(getListRecordSuccess([]));
                          dispatch(setDataList([]));
                        }
                        if (
                          item.object_id === "obj_quotations_00000001" ||
                          item.object_id === "obj_quotation_items_00000001"
                        ) {
                          navigate("/sale-view/obj_quotations_00000001");
                        } else if (
                          item.object_id === "obj_opportunities_00000001" ||
                          item.object_id === "obj_sale_orders_00000001"
                        ) {
                          navigate(`/sale-view/${item.object_id}`);
                        } else if (item.object_id === "obj_products_00000001") {
                          navigate(`/product-list`);
                        } else {
                          navigate(`objects/${item.object_id}/default-view`);
                        }
                      }
                    }}
                  >
                    <TextComponent
                      style={{
                        color: `${
                          objectId === item.object_id ||
                          (object_id === item.object_id) |
                            (objectID === item.object_id)
                            ? defaultBrandName.theme_color
                            : "#637381"
                        }`,
                      }}
                      ellipsis={{ tooltip: item.object_name }}
                    >
                      {item.object_name}
                    </TextComponent>
                  </MenuItem>
                </WrapItem>
              );
            }
            return null;
          }
          return null;
        })}
      </CarouselWrap>
    </CustomMenuHeader>
  );
};

export default HeaderObjectView;

const WraperButton = styled.div`
  opacity: 0;
  user-select: none;
  transition: 0.3s all ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  width: 11rem;
  padding: 0.6rem;
  background: linear-gradient(
    268.32deg,
    #ffffff 37.93%,
    rgba(255, 255, 255, 0) 91.95%
  );

  button {
    cursor: pointer;
    border: none;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #454f5b;
    width: 2.4rem;
    height: 2.4rem;
    img {
      height: 0.8rem;
      width: auto;
      object-fit: cover;
    }
  }
`;

const CustomMenuHeader = styled.div`
  /* padding-left: 1rem; */
  flex: 1;
  display: flex;
  justify-content: space-between;
  ul {
    li {
      display: flex;
      justify-content: center;
    }
  }
`;

const CarouselWrap = styled.div`
  margin-left: 1rem;
  &:hover ${WraperButton} {
    opacity: 1;
    transition: 0.3s all ease;
    user-select: initial;
  }
  overflow: auto;
  display: flex;
  flex: 1;
  width: 400px;
  overflow: auto;
  .react-multi-carousel-list {
    .react-multi-carousel-track {
      .react-multi-carousel-item {
        position: relative;

        &::before {
          content: "";
          width: 0.1rem;
          height: 50%;
          background-color: #ccd4dd;
          position: absolute;
          z-index: 2;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }

  :hover {
    .react-multiple-carousel__arrow--right,
    .react-multiple-carousel__arrow--left {
      visibility: visible;
      opacity: 1;
    }
  }
  .react-multiple-carousel__arrow--right {
    visibility: hidden;
    opacity: 0;
    right: 0;
  }
  .react-multiple-carousel__arrow--left {
    visibility: hidden;
    opacity: 0;
    left: 0;
  }

  .react-multiple-carousel__arrow {
    min-width: unset;
    min-height: unset;
    width: 2.8rem;
    height: 2.8rem;
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    background: ${(props) => props.color};
    ::before {
      color: #2c2c2c;
      font-size: 1.2rem;
      font-weight: 600;
    }
    :hover {
      background: ${(props) => props.theme.main};
      ::before {
        color: #fff;
      }
    }
  }
  &::-webkit-scrollbar {
    display: none !important;
  }
`;

const MenuItem = styled.div`
  font-size: 1.3rem;
  line-height: 2.2rem;
  text-align: center;
  color: #2c2c2c;
  padding: 0.6rem 1rem;
  border-radius: 0.8rem;
  height: calc(100% - 0.1rem);
  width: fit-content;
  max-width: 25rem;
  transition: all 0.5s;
  background: ${(props) => (props.isActive ? props.color : "#fff")};

  &:hover {
    background: #919eab29;
    color: #212b36 !important;
    cursor: pointer;
  }
`;

const CustomDropdown = styled(Dropdown)`
  border: none;
  font-style: normal;
  font-family: var(--roboto-400);
  font-size: 1.6rem;
  line-height: 2.2rem;
  text-align: center;

  color: #2c2c2c;

  display: flex;
  justify-content: center;
  align-items: center;

  .ant-dropdown-menu-submenu-title:hover {
    background-color: #e6f7ff;
    color: ${(props) => props.theme.darker};
  }
  .ant-dropdown-menu-item:hover {
    background-color: #e6f7ff;
    color: ${(props) => props.theme.darker};
  }
`;

const CustomNewButton = styled.div`
  &:hover {
    background: #919eab29;
    transition: 0.2s all ease;
    border: 0.1rem solid transparent;
  }
  transition: 0.2s all ease;
  background: #fff;
  border: 0.1rem solid #d9d9d9;
  height: 3.3rem;
  border-radius: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
  padding: 0 0.6em;
  font-size: 1.3rem;
  cursor: pointer;
  span {
    white-space: nowrap;
    font-family: var(--roboto-500);
    text-align: left;
    color: #000;
    display: flex;
    align-items: center;
    svg {
      font-size: 1.3rem;
      margin-left: 0.5rem;
      color: ${(props) => props.theme.main};
    }
  }
`;

const WrapItem = styled.div`
  padding: 0 1rem;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 0.1rem;
    height: 50%;
    left: 0;
    top: 25%;
    background: #d9d9d9;
  }
`;

const ContenWrap = styled.div`
  width: 24rem;
  padding: 1rem;
  .ant-collapse-header {
    border-bottom: 0.1rem solid #919eab3d;
    padding: 0.7rem 1.6rem !important;
    font-size: 1.3rem !important;
  }
  .ant-collapse-item-active {
    .ant-collapse-header-text {
      font-family: var(--roboto-700);
    }
  }
  .ant-collapse-header-text {
    padding-right: 1rem;
  }
  .ant-collapse-expand-icon {
    svg {
      font-size: 1.3rem;
    }
  }
  .ant-collapse-content-box {
    padding: 0 !important;
  }
  ul {
    margin: 0 !important;
    padding-left: 4rem;
  }
  .ant-input:focus,
  .ant-input-focused,
  .ant-input:not(.ant-input-disabled):hover,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    box-shadow: none;
    border-color: ${(props) => props.theme.main};
  }
  .ant-input-affix-wrapper,
  .ant-input {
    border-radius: 0.6rem;
    svg {
      color: ${(props) => props.theme.main};
    }
  }
  .ant-input:placeholder-shown {
    font-size: 1.3rem;
  }
`;
const CustomName = styled.li`
  cursor: pointer;
  font-family: ${(props) =>
    props.isActive ? "var(--roboto-500)" : "var(--roboto-400)"};
  font-size: 1.3rem;
  line-height: 1.8rem;
  padding: 0.7rem 0;
  .ant-typography {
    color: ${(props) =>
      props.isActive ? props.theme.main : "#000"} !important;
  }
  ::marker {
    color: ${(props) => (props.isActive ? props.theme.main : "#000")};
    font-size: ${(props) => (props.isActive ? "1.6rem" : "unset")};
  }
`;

const ItemWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 12px;

  .pin-icon {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out;
  }

  :hover {
    .pin-icon {
      opacity: 1;
      visibility: visible;
    }
  }
`;
